<!-- addons.vue -->
<template>
  <div>
    <v-card class="pa-4 mb-6">
      <h2 class="text-h5 font-weight-bold mb-4">Manage Add-Ons</h2>
      <v-form ref="addOnForm" v-model="valid" @submit.prevent="addAddOn">
        <v-text-field
          v-model="newAddOn.name"
          label="Add-On Name"
          :rules="[requiredRule]"
          required
          class="mb-4"
        ></v-text-field>
        <v-text-field
          v-model="newAddOn.price"
          label="Price (OMR)"
          :rules="[priceRule]"
          required
          type="number"
          min="0"
          step="0.01"
          class="mb-4"
        ></v-text-field>
        <v-btn color="primary" :disabled="!valid" @click="addAddOn">
          Add Add-On
        </v-btn>
      </v-form>
    </v-card>

    <v-simple-table class="elevated-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Price (OMR)</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="addOn in addOns" :key="addOn.id">
          <td>{{ addOn.id }}</td>
          <td>{{ addOn.name }}</td>
          <td>
            <span v-if="addOn.price !== undefined && addOn.price !== null">
              {{ addOn.price.toFixed(2) }}
            </span>
            <span v-else>N/A</span>
          </td>
          <td>
            <v-btn color="red" small @click="deleteAddOn(addOn.id)">
              Delete
            </v-btn>
          </td>
        </tr>
        <tr v-if="addOns.length === 0">
          <td colspan="4" class="text-center">No Add-Ons Available.</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import apiService from '@/services/apiService.js';

export default {
  name: "AddOns",
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      addOns: [],
      newAddOn: {
        name: "",
        price: null
      },
      valid: false,
    };
  },
  computed: {
    requiredRule() {
      return v => !!v || "This field is required";
    },
    priceRule() {
      return v => (v > 0) || "Price must be greater than 0";
    },
  },
  methods: {
    fetchAddOns() {
      apiService.fetchAddOns(this.token)
        .then(res => {
          this.addOns = res.data;
        })
        .catch(err => {
          this.$emit('error', err.response?.data?.error || "Failed to fetch add-ons.");
        });
    },
    addAddOn() {
      if (!this.valid) return;
      const payload = {
        name: this.newAddOn.name,
        price: parseFloat(this.newAddOn.price)
      };
      apiService.createAddOn(payload, this.token)
        .then(res => {
          this.addOns.push(res.data.addon);
          this.newAddOn.name = "";
          this.newAddOn.price = null;
          this.$refs.addOnForm.reset();
        })
        .catch(err => {
          this.$emit('error', err.response?.data?.error || "Failed to add new add-on.");
        });
    },
    deleteAddOn(addOnId) {
      if (!confirm("Are you sure you want to delete this add-on?")) return;
      apiService.deleteAddOn(addOnId, this.token)
        .then(() => {
          this.addOns = this.addOns.filter(addOn => addOn.id !== addOnId);
        })
        .catch(err => {
          this.$emit('error', err.response?.data?.error || "Failed to delete add-on.");
        });
    },
  },
  mounted() {
    this.fetchAddOns();
  }
};
</script>

<style scoped>
.elevated-table {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

::v-deep .elevated-table table {
  border-collapse: separate !important;
  border-spacing: 0 6px !important;
}

::v-deep .elevated-table th,
::v-deep .elevated-table td {
  padding: 16px 24px !important;
  text-align: left !important;
  vertical-align: middle !important;
}

.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 16px;
}
</style>
